module.exports = __webpack_public_path__ + "img/pr-5.66667490.png";